export default {
  isLogin: false,
  ticket: "", // 5e309bde-aef6-431a-bef8-f752ecb53b73
  userInfo: {},
  agentId: null, // 代理Id
};
